<script setup lang="ts">
import { toRef } from 'vue';
import type { AnswersByQuestion, MatrixColumn, MatrixPlayer } from '../../util/answerRecapMatrix';
import { useQuestionBreakdown } from '../../composables/useQuestionBreakdown';
import HostResultsDialog from './results/HostResultsDialog.vue';
import AnswerDistributionRow from './results/AnswerDistributionRow.vue';
import useLocale from '../../../composables/use-locale';

const props = defineProps<{
  modelValue: boolean;
  column: MatrixColumn | null;
  questionCount: number;
  answersByQuestion: AnswersByQuestion;
  players: MatrixPlayer[];
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void;
}>();

const { t } = useLocale();

const { alternatives, isExpanded, toggle } = useQuestionBreakdown({
  isOpen: toRef(props, 'modelValue'),
  column: toRef(props, 'column'),
  answersByQuestion: toRef(props, 'answersByQuestion'),
  players: toRef(props, 'players'),
});
</script>

<template>
  <HostResultsDialog
    :model-value="modelValue"
    :title="column?.phrase ?? ''"
    :subtitle="
      t('results.answer_recap.question_of', { number: (column?.questionIndex ?? 0) + 1, total: questionCount }) +
      ' · ' +
      t('results.answer_recap.pct_correct_value', { pct: column?.pctCorrect ?? 0 }) +
      ' · ' +
      t('results.answer_recap.answered_count', { count: column?.answered ?? 0 })
    "
    test-id="quizter-question-breakdown"
    @update:model-value="emit('update:modelValue', $event)"
  >
    <AnswerDistributionRow
      v-for="alternative in alternatives"
      :key="alternative.id"
      :alternative="alternative"
      :expanded="isExpanded(alternative.id)"
      @toggle="toggle(alternative.id)"
    />
  </HostResultsDialog>
</template>
